import { Text } from '@/local/components'
import { Box } from '@mui/material'
import { useTexts } from '../useTexts'

interface Props {
  count: number
}

const growStyle = {
  padding: '2px 0',
  maxWidth: 260,
  minWidth: 260,
  height: '100%',
  alignItems: 'center',
}

export function Bulk(props: Props) {
  const { count } = props

  const texts = useTexts()

  return (
    <Box
      data-trackid="navigo-device-overview-details-bulk"
      data-testid="navigo-device-overview-details-bulk"
      sx={growStyle}
      width="100%"
      flex="0 1 auto"
    >
      <Text
        data-trackid="navigo-device-overview-details-bulk-number"
        data-testid="navigo-device-overview-details-bulk-number"
        weight="$semiBold"
        size="$xl"
      >
        {texts.devicesCounter(count)}
      </Text>
    </Box>
  )
}
